import { configureStore } from '@reduxjs/toolkit';
import yearReducer from './../features/yearSlice';

export const store = configureStore({
    reducer: {
        years: yearReducer,
    },
});
